import styled from "styled-components";

const StyledFormTagSelect = styled.div`
	width: 100%;
	overflow: auto;
	.ant-select:not(.ant-select-customize-input) {
		.ant-select-selector {
			border: 1px solid ${({ theme }) => theme.colors.iron};
			border-radius: 24px;
			padding: 1px 10px;
		}
		.ant-select-selection-search {
			width: 100% !important;
		}
	}
	.ant-select-multiple .ant-select-selection-overflow-item-suffix {
		flex: 1;
	}
	.ant-select-multiple.ant-select-lg {
		height: 48px;
	}

	.ant-select-selection-item {
		background: ${({ theme }) => theme.colors.athensGray};
		padding: 0 14px;
		height: 24px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 100px !important;
		border: none !important;
		margin: 0;
		font-weight: normal;

		.ant-select-selection-item-content {
			margin-right: 8px;
			font-style: normal;

			font-size: 12px;
			line-height: 22px;
			letter-spacing: 0.1px;
		}

		.ant-select-selection-item-remove {
			color: ${({ theme }) => theme.colors.coral};
			font-size: 12px;
		}
	}

	.ant-select-selection-placeholder {
		padding: 0 10px;
	}
`;

export default StyledFormTagSelect;

